<template>
    <div class="min-h-app container mx-auto py-16 flex flex-col justify-center">
        <div>
            <Info v-if="messages" :closeable="true" v-model:data="messages" />

            <div class="text-center">
                <Icon type="Basket" viewBox="0 0 16 21" width="121" height="121" class="mx-auto fill-current text-red" />

                <h1 class="mt-8">
                    {{ $t('order_failed') }}
                </h1>
                <p class="mt-8">
                    {{ $t('order_failed_message') }}
                </p>

                <FormButton @click="$router.push('/checkout')" class="mt-8 mx-auto" styling="primary" :value="$t('go_to_checkout')" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        messages: null
    }),

    mounted() {
        if (window.meta.messages) {
            this.messages = window.meta.messages;
        }
    }
};
</script>
